export default function getPageId(): string {
    return window.location.href.replace('https://', '').replace('http://', '')
}
